import { useTheme } from "@mui/material";
import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const RomanianPhoneInput = ({
  value,
  onChange,
  inputError,
  inputStyle,
  buttonStyle,
}) => {
  const theme = useTheme();
  return (
    <PhoneInput
      country={"ro"}
      value={value}
      onChange={onChange}
      countryCodeEditable={false}
      disableDropdown={true}
      inputProps={{
        name: "contact",
        required: true,
        autoFocus: true,
      }}
      inputStyle={{
        width: "100%",
        borderColor: inputError ? "#d32f2f" : theme.palette.primary.main,
        padding: "22px 50px",
        borderRadius: "5px",
        ...inputStyle,
      }}
      buttonStyle={{
        borderRadius: "5px 0px 0px 5px",
        borderColor: inputError ? "#d32f2f" : theme.palette.primary.main,
        ...buttonStyle,
      }}
    />
  );
};

export default RomanianPhoneInput;
